import React from 'react';
import { AnnouncementBar } from '../components/sections/AnnouncementBar';
import { HeroBannerSlider } from '../components/sections/HeroBannerSlider';
import { Hero } from '../components/sections/Hero';
import { SolutionsSection } from '../components/sections/SolutionsSection';
import { ProcessSection } from '../components/sections/ProcessSection';
import { TechnologySection } from '../components/sections/TechnologySection';
import { KitSection } from '../components/sections/KitSection';
import { PlansSection } from '../components/sections/PlansSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { FinalCTA } from '../components/sections/FinalCTA';
import { ContactSection } from '../components/sections/ContactSection';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
interface HomePageProps {
  onCTA: (id: string) => void;
}
export function HomePage({
  onCTA
}: HomePageProps) {
  useDocumentMeta({
    title: 'Alinova | Alineadores invisibles para ortodoncistas en Colombia',
    description: 'Fabricación de alineadores invisibles en Colombia para odontólogos y ortodoncistas, con validación clínica, certificación INVIMA y presentación eco-premium en cada caso.',
    path: '/'
  });
  return <main data-id="element-900" data-mp="2jjj8slpagnk0">
      <AnnouncementBar data-id="element-901" data-mp="2og9z01ut4zj5" />
      <HeroBannerSlider data-id="element-902" data-mp="2ogjfmytypuc6" />
      <Hero onCTA={onCTA} data-id="element-903" data-mp="2oeynffv4enhh" />
      <SolutionsSection onCTA={onCTA} data-id="element-904" data-mp="2oidzsaxetif7" />
      <ProcessSection onCTA={onCTA} data-id="element-905" data-mp="1rqisf498rlwz" />
      <TechnologySection data-id="element-906" data-mp="1rrlkvgm7pwf0" />
      <KitSection onCTA={onCTA} data-id="element-907" data-mp="1rsdiewzde47x" />
      <PlansSection data-id="element-908" data-mp="1vr2tgiwxr9oe" />
      <TestimonialsSection data-id="element-909" data-mp="1vsdtc7n9fxa8" />
      <FinalCTA onCTA={onCTA} data-id="element-910" data-mp="1vtoyaasfzb2x" />
      <ContactSection data-id="element-911" data-mp="20qytk72iigyo" />
    </main>;
}